/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from '@material-ui/core'
import Button from '@mui/material/Button'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Stack } from '@mui/material'
import NumberFormat from 'react-number-format'
import Swal from 'sweetalert2'
import ReactTooltip from 'react-tooltip'
import ExitIcon from '@material-ui/icons/ExitToApp'
import SaveIcon from '@material-ui/icons/Save'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import { useHistory } from 'react-router-dom'
import { Table17 } from './Tables/TableSec1/Table17'
import { Table13 } from './Tables/TableSec1/Table13'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { getCountryByID, getIFI } from '../../../services/IFI/get'
import {
  getCurrency,
  getCurrencyByCountry,
} from '../../../services/Elegibilidad/get'
import {
  insertTechnicalAssistanceAnswers,
  reportCapacityBuilding,
  reportCapacityBuildingIFI,
  reportTechnicalAssistancePreinvestment,
} from '../../../services/AsistenciaTecnica/create'
import swal from 'sweetalert'
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import {
  GetIfiHasDisbursement,
  GetTechnicalAssistanceAnswers,
} from '../../../services/AsistenciaTecnica/get'
import { useAuthentication } from '../../../context/authenticationContext'
import { useFormTechnicalAssistance } from '../../../context/TechnicalAssistanceContext'
import { useAsistencia } from '../../../context/AsistenciaContext'
import ROUTES from '../../../routers/routes'
import { LoadingButton } from '@mui/lab'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { Popup } from 'devextreme-react'
import { validateEditForm } from '../../../services/Forms/create'

export const AsistenciaSeccion1 = (props) => {
  const history = useHistory()
  const { goToStep, edit, idForm, nextStep } = props
  const [, dispatch, , setEnableSec3] = useAsistencia()
  const { userCountry, userIDB2C, IdIFIToken } = useAuthentication()
  const [currencyType, setCurrencyType] = useState([])
  const { assistanceForm, setAssistanceForm } = useFormTechnicalAssistance()
  const [editableCode, setEditableCode] = useState('')
  const [phone, setPhone] = useState(userCountry === '7' ? '1809' : '')
  const [backup, setBackup] = useState('')
  const [disabled, setDisabled] = useState(false)
  const [loading, setLoading] = useState(true)
  const [requestValidate, setrequestValidate] = useState(false)
  const [open, setOpen] = useState(false)
  const [loadingPDF, setLoadingPDF] = useState(false)
  const [popupVisible, setPopupVisible] = useState(false)
  const [reportDownload, setReportDownload] = useState('')

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    nextStep()
  }

  const valueDate = {
    someDate: new Date().toISOString().substring(0, 10),
  }

  const getEditFormTechnicalAssistance = async (idForm) => {
    try {
      const response = await GetTechnicalAssistanceAnswers(idForm)
      if (response.Success) setAssistanceForm(response.Data)
      setLoading(false)
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (idForm !== 0) {
      getEditFormTechnicalAssistance(idForm)
    } else setLoading(false)
  }, [])

  const getIFIbyid = async () => {
    try {
      const response = await getIFI(IdIFIToken)
      if (response.Success) {
        formik.setFieldValue('NameIFI', response.Data.BusinessName)
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const GeneralDataSchema = Yup.object().shape({
    IdBeneficiaryType: Yup.number()
      .required('Esta campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    IdTechnicalAssistanceType: Yup.number().moreThan(
      0,
      'Este campo es obligatorio',
    ),
    IdCurrency: Yup.number()
      .required('Esta campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    RequestedAmount: Yup.number()
      .required('Este campo es obligatorio')
      .test('superior', 'El monto debe ser mayor que 0.00', function (f) {
        const ref = 0
        return f > this.resolve(ref)
      })
      .typeError('Este campo es obligatorio'),
    ContactPhoneNumber: Yup.string().required('Este campo es obligatorio'),
    ContactEmail: Yup.string()
      .email('El formato del email no es válido')
      .required('Este campo es requerido'),
    ContactAdress: Yup.string().required('Este campo es obligatorio'),
    IfiBenefitCharge: Yup.boolean().oneOf([true], 'Este campo es obligatorio'),
    MipymeDeclares: Yup.boolean().oneOf([true], 'Este campo es obligatorio'),
    UnderConditions: Yup.boolean().oneOf([true], 'Este campo es obligatorio'),
    TechnicalAssistanceReceivedNumber: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    validateTable17: Yup.boolean().oneOf(
      [true],
      'Los datos de esta tabla son obligatorios y el número de registros deben coincidir con el número de asistencias técnicas',
    ),
    ATPOtherDescription: Yup.string()
      .max(80, 'Máximo 80 caracteres')
      .when('ATPOther', {
        is: true,
        then: Yup.string().required('Este campo es obligatorio'),
      }),
    validateTable13: Yup.boolean().when('IdBeneficiaryType', {
      is: (IdBeneficiaryType) =>
        IdBeneficiaryType === 1 || IdBeneficiaryType === 3,
      then: Yup.boolean().oneOf(
        [true],
        'Los datos de esta tabla son obligatorios y el número de registros deben coincidir con el número de MIPYME',
      ),
    }),
    NumberOfApplicants: Yup.number()
      .required('Este campo es obligatorio')
      .when('IdBeneficiaryType', {
        is: 3,
        then: Yup.number()
          .required('Este campo es obligatorio')
          .min(2, 'El número de MIPYME debe ser mayor o igual a 2 '),
      }),
    CCMOtherDescription: Yup.string()
      .max(80, 'Máximo 80 caracteres')
      .when('CCMOther', {
        is: true,
        then: Yup.string().required('Este campo es obligatorio'),
      }),
    validateTechnicalAssistanceforPreinvestment: Yup.boolean().when(
      'IdTechnicalAssistanceType',
      {
        is: (IdTechnicalAssistanceType) => IdTechnicalAssistanceType === 4,
        then: Yup.boolean().oneOf(
          [true],
          'Seleccione al menos una asistencia técnica',
        ),
      },
    ),
    validateTechnicalAssistanceCapacityBuildingForMipymes: Yup.boolean().when(
      'IdTechnicalAssistanceType',
      {
        is: (IdTechnicalAssistanceType) => IdTechnicalAssistanceType === 5,
        then: Yup.boolean().oneOf(
          [true],
          'Seleccione al menos una asistencia técnica',
        ),
      },
    ),
    validateTechnicalCapacityBuildingForIFI: Yup.boolean().when(
      'IdTechnicalAssistanceType',
      {
        is: (IdTechnicalAssistanceType) => IdTechnicalAssistanceType === 3,
        then: Yup.boolean().oneOf(
          [true],
          'Seleccione al menos una asistencia técnica',
        ),
      },
    ),
  })

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      IdBeneficiaryType: assistanceForm.IdBeneficiaryType || 1,
      IdTechnicalAssistanceType: assistanceForm.IdTechnicalAssistanceType || 4,
      IFICountry: assistanceForm.IFICountry || '',
      IdCurrency: assistanceForm.IdCurrency || null,
      ContactPhoneNumber: assistanceForm.ContactPhoneNumber || '',
      ContactEmail: assistanceForm.ContactEmail || '',
      ContactAdress: assistanceForm.ContactAdress || '',
      TechnicalAssistanceReceivedNumber:
        assistanceForm.TechnicalAssistanceReceivedNumber || 0,
      Draft: assistanceForm.Draft || true,
      IdTechnicalAssistanceAnswer:
        assistanceForm.IdTechnicalAssistanceAnswer || 0,
      IdUserAzureB2C: userIDB2C,
      IdIFI: assistanceForm.IdIFI || IdIFIToken,
      IdForm: assistanceForm.IdForm || 0,
      IfiBenefitCharge: assistanceForm.IfiBenefitCharge || false,
      MipymeDeclares: assistanceForm.MipymeDeclares || false,
      UnderConditions: assistanceForm.UnderConditions || false,
      IdCountry: assistanceForm.IdCountry || Number(userCountry),
      RequestedAmount: assistanceForm.RequestedAmount || null,
      NumberOfApplicants: assistanceForm.NumberOfApplicants || 1,
      ATPDesign: assistanceForm.ATPDesign || false,
      ATPEvaluationsEnvironment:
        assistanceForm.ATPEvaluationsEnvironment || false,
      ATPFinancialAndEconomicEvaluations:
        assistanceForm.ATPFinancialAndEconomicEvaluations || false,
      ATPFeasibilityStudies: assistanceForm.ATPFeasibilityStudies || false,
      ATPBusinessPlanSupport: assistanceForm.ATPBusinessPlanSupport || false,
      ATPSupportResourcesWomen:
        assistanceForm.ATPSupportResourcesWomen || false,
      ATPOther: assistanceForm.ATPOther || false,
      ATPOtherDescription: assistanceForm.ATPOtherDescription || '',
      CCMConstructionClimateChange:
        assistanceForm.CCMConstructionClimateChange || false,
      CCMOrganizationalSkills: assistanceForm.CCMOrganizationalSkills || false,
      CCMGenderRelatedSkills: assistanceForm.CCMGenderRelatedSkills || false,
      CCMOther: assistanceForm.CCMOther || false,
      CCMImplementationProcessesClimateChange:
        assistanceForm.CCMImplementationProcessesClimateChange || false,
      CCMOtherDescription: assistanceForm.CCMOtherDescription || '',
      CCIClimateChangeAdaptation:
        assistanceForm.CCIClimateChangeAdaptation || false,
      CCIClimateChange: assistanceForm.CCIClimateChange || false,
      CCIGenderRelatedSkillsTraining:
        assistanceForm.CCIGenderRelatedSkillsTraining || false,
      CCIFinancialProductDesign:
        assistanceForm.CCIFinancialProductDesign || false,
      CCIEvaluationCriteriaAnalysis:
        assistanceForm.CCIEvaluationCriteriaAnalysis || false,
      CCIMonitoringEvaluation: assistanceForm.CCIMonitoringEvaluation || false,
      CCIOther: assistanceForm.CCIOther || false,
      CCIOtherDescription: assistanceForm.CCIOtherDescription || '',
      Validate: false,
      validateTable17: false,
      PresentationDate: assistanceForm.PresentationDate || valueDate.someDate,
      validateTechnicalAssistanceforPreinvestment: false,
      validateTechnicalAssistanceCapacityBuildingForMipymes: false,
      validateTechnicalCapacityBuildingForIFI: false,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  useEffect(() => {
    if (formik.values.IdBeneficiaryType === 2) {
      if (
        formik.values.CCIClimateChangeAdaptation === true ||
        formik.values.CCIClimateChange === true ||
        formik.values.CCIGenderRelatedSkillsTraining === true ||
        formik.values.CCIFinancialProductDesign === true ||
        formik.values.CCIEvaluationCriteriaAnalysis === true ||
        formik.values.CCIMonitoringEvaluation === true ||
        formik.values.CCIOther === true
      )
        setDisabled(true)
    }
  }, [
    formik.values.CCIClimateChangeAdaptation,
    formik.values.CCIClimateChange,
    formik.values.CCIGenderRelatedSkillsTraining,
    formik.values.CCIFinancialProductDesign,
    formik.values.CCIEvaluationCriteriaAnalysis,
    formik.values.CCIMonitoringEvaluation,
    formik.values.CCIOther,
  ])

  useEffect(() => {
    if (assistanceForm && assistanceForm.ContactPhoneNumber) {
      setPhone(assistanceForm.ContactPhoneNumber)
      formik.setFieldValue(
        'ContactPhoneNumber',
        assistanceForm.ContactPhoneNumber,
      )
    }
  }, [assistanceForm])

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  useEffect(() => {
    if (formik.values.IdBeneficiaryType === 2) {
      setEnableSec3(true)
    } else setEnableSec3(false)
  }, [formik.values.IdBeneficiaryType])

  const getIFICountry = async () => {
    try {
      const response = await getCountryByID(userCountry)
      if (response.Success) {
        formik.setFieldValue('IFICountry', response.Data.LargeName)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  //  Función para obtener la moneda por pais
  const getListCurrencyByCountry = async () => {
    try {
      const response = await getCurrencyByCountry(userCountry)
      if (response.Success) {
        setCurrencyType(response.Data)
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const handleEdit = (e) => {
    if (phone !== '') {
      setBackup(phone)
    } else {
      setBackup('')
    }

    if (e.key === 'Backspace' && phone.length <= 4) {
      setEditableCode(false)
    } else {
      setEditableCode(true)
    }
  }

  useEffect(() => {
    if (backup) {
      if (phone === '' || phone.charAt(0) !== '1' || phone.length < 4) {
        setPhone(backup)
        formik.setFieldValue('companyPhone', backup)
      }
    }
  }, [phone])
  useEffect(() => {
    if (backup) {
      if (phone === '' || phone.charAt(0) !== '1' || phone.length < 4) {
        setPhone(backup)
        formik.setFieldValue('companyPhone', backup)
      }
    }
  }, [phone])

  useEffect(() => {
    getIFICountry()
    getListCurrencyByCountry()
  }, [])

  const getIfiHasDisbursementValidate = async () => {
    try {
      const response = await GetIfiHasDisbursement(IdIFIToken)
      if (response.Success) {
        if (response.Data.TreasuryNumber !== null) {
          getIFIbyid()
        } else {
          Swal.fire({
            title: `IFI no ha realizado Desembolsos`,
            icon: 'error',
            showCancelButton: true,
            showConfirmButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Aceptar',
          }).then((result) => {
            if (result.isDismissed) {
              history.push('/')
            }
          })
        }
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    if (formik.values.IdBeneficiaryType === 2) {
      getIfiHasDisbursementValidate()
    }
  }, [formik.values.IdBeneficiaryType])

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          formik.values.IdTechnicalAssistanceAnswer,
        )

        if (response.Success) {
          const exit = true
          saveForm(formik.values, true, exit)
        }
      } else if (result.isDenied) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          formik.values.IdTechnicalAssistanceAnswer,
        )
        if (response.Success) {
          if (edit) {
            history.push(ROUTES.IFIBORRADOR.pathname)
            dispatch({ type: 'SET_STATE', payload: 1 })
          } else {
            history.push('/')
            dispatch({ type: 'SET_STATE', payload: 1 })
          }
        }
      }
    })
  }

  const handleCurrency = async () => {
    let currency
    switch (formik.values.IdCurrency) {
      case 1:
        currency = 'HNL'
        break
      case 2:
        currency = 'NIC'
        break
      case 3:
        currency = 'DOM'
        break
      case 4:
        currency = 'CRC'
        break
      case 5:
        currency = 'GTQ'
        break
      case 6:
        currency = 'DOP'
        break
    }

    const dataCurrency = {
      SourceCurrencyCode: 'USD',
      TargetCurrencyCode: currency,
      OriginalAmount: 1,
    }

    if (formik.values.IdCurrency !== 3) {
      try {
        const response = await getCurrency(dataCurrency)
        if (response.error === null) {
          const Exchange =
            response.result
              .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
              .currencyExchange.resultingAmount

          formik.setFieldValue('CurrencyToDollarExchangeRate', Exchange)
        }
      } catch (error) {
        console.log(error)
      }
    } else {
      formik.setFieldValue('CurrencyToDollarExchangeRate', 1)
    }
  }

  useEffect(() => {
    if (
      formik.values.IdCurrency !== undefined &&
      formik.values.IdCurrency !== null
    ) {
      handleCurrency()
    }
  }, [formik.values.IdCurrency])

  const handleChangeTechnicalAssistanceforPreinvestment = (e) => {
    switch (e.target.value) {
      case 'ATPDesign':
        if (e.target.checked === true) {
          formik.setFieldValue('ATPDesign', true)
        } else {
          formik.setFieldValue('ATPDesign', false)
        }
        break

      case 'ATPEvaluationsEnvironment':
        if (e.target.checked === true) {
          formik.setFieldValue('ATPEvaluationsEnvironment', true)
        } else {
          formik.setFieldValue('ATPEvaluationsEnvironment', false)
        }
        break

      case 'ATPFinancialAndEconomicEvaluations':
        if (e.target.checked === true) {
          formik.setFieldValue('ATPFinancialAndEconomicEvaluations', true)
        } else {
          formik.setFieldValue('ATPFinancialAndEconomicEvaluations', false)
        }
        break

      case 'ATPFeasibilityStudies':
        if (e.target.checked === true) {
          formik.setFieldValue('ATPFeasibilityStudies', true)
        } else {
          formik.setFieldValue('ATPFeasibilityStudies', false)
        }
        break

      case 'ATPBusinessPlanSupport':
        if (e.target.checked === true) {
          formik.setFieldValue('ATPBusinessPlanSupport', true)
        } else {
          formik.setFieldValue('ATPBusinessPlanSupport', false)
        }
        break

      case 'ATPSupportResourcesWomen':
        if (e.target.checked === true) {
          formik.setFieldValue('ATPSupportResourcesWomen', true)
        } else {
          formik.setFieldValue('ATPSupportResourcesWomen', false)
        }
        break

      case 'ATPOther':
        if (e.target.checked === true) {
          formik.setFieldValue('ATPOther', true)
        } else {
          formik.setFieldValue('ATPOther', false)
        }
        break

      default:
        formik.setValues({
          ...formik.values,
          ATPDesign: false,
          ATPEvaluationsEnvironment: false,
          ATPFinancialAndEconomicEvaluations: false,
          ATPFeasibilityStudies: false,
          ATPBusinessPlanSupport: false,
          ATPSupportResourcesWomen: false,
          ATPOther: false,
        })
        break
    }
  }

  useEffect(() => {
    if (
      formik.values.ATPDesign === true ||
      formik.values.ATPEvaluationsEnvironment === true ||
      formik.values.ATPFinancialAndEconomicEvaluations === true ||
      formik.values.ATPFeasibilityStudies === true ||
      formik.values.ATPBusinessPlanSupport === true ||
      formik.values.ATPSupportResourcesWomen === true ||
      formik.values.ATPOther
    ) {
      formik.setFieldValue('validateTechnicalAssistanceforPreinvestment', true)
    } else {
      formik.setFieldValue('validateTechnicalAssistanceforPreinvestment', false)
    }
  }, [
    formik.values.ATPDesign,
    formik.values.ATPEvaluationsEnvironment,
    formik.values.ATPFinancialAndEconomicEvaluations,
    formik.values.ATPFeasibilityStudies,
    formik.values.ATPBusinessPlanSupport,
    formik.values.ATPSupportResourcesWomen,
    formik.values.ATPOther,
  ])

  const handleChangeCapacityBuildingForMipymes = (e) => {
    switch (e.target.value) {
      case 'CCMConstructionClimateChange':
        if (e.target.checked === true) {
          formik.setFieldValue('CCMConstructionClimateChange', true)
        } else {
          formik.setFieldValue('CCMConstructionClimateChange', false)
        }
        break

      case 'CCMOrganizationalSkills':
        if (e.target.checked === true) {
          formik.setFieldValue('CCMOrganizationalSkills', true)
        } else {
          formik.setFieldValue('CCMOrganizationalSkills', false)
        }
        break

      case 'CCMGenderRelatedSkills':
        if (e.target.checked === true) {
          formik.setFieldValue('CCMGenderRelatedSkills', true)
        } else {
          formik.setFieldValue('CCMGenderRelatedSkills', false)
        }
        break

      case 'CCMImplementationProcessesClimateChange':
        if (e.target.checked === true) {
          formik.setFieldValue('CCMImplementationProcessesClimateChange', true)
        } else {
          formik.setFieldValue('CCMImplementationProcessesClimateChange', false)
        }
        break
      case 'CCMOther':
        if (e.target.checked === true) {
          formik.setFieldValue('CCMOther', true)
        } else {
          formik.setFieldValue('CCMOther', false)
        }
        break

      default:
        formik.setValues({
          ...formik.values,
          CCMConstructionClimateChange: false,
          CCMOrganizationalSkills: false,
          CCMGenderRelatedSkills: false,
          CCMOther: false,
          CCMImplementationProcessesClimateChange: false,
        })
        break
    }
  }

  useEffect(() => {
    if (
      formik.values.CCMConstructionClimateChange === true ||
      formik.values.CCMOrganizationalSkills === true ||
      formik.values.CCMGenderRelatedSkills === true ||
      formik.values.CCMOther === true ||
      formik.values.CCMImplementationProcessesClimateChange === true
    ) {
      formik.setFieldValue(
        'validateTechnicalAssistanceCapacityBuildingForMipymes',
        true,
      )
    } else {
      formik.setFieldValue(
        'validateTechnicalAssistanceCapacityBuildingForMipymes',
        false,
      )
    }
  }, [
    formik.values.CCMConstructionClimateChange,
    formik.values.CCMOrganizationalSkills,
    formik.values.CCMGenderRelatedSkills,
    formik.values.CCMOther,
    formik.values.CCMImplementationProcessesClimateChange,
  ])

  const handleChangeCapacityBuildingForIFI = (e) => {
    switch (e.target.value) {
      case 'CCIClimateChangeAdaptation':
        if (e.target.checked === true) {
          formik.setFieldValue('CCIClimateChangeAdaptation', true)
        } else {
          formik.setFieldValue('CCIClimateChangeAdaptation', false)
        }
        break

      case 'CCIClimateChange':
        if (e.target.checked === true) {
          formik.setFieldValue('CCIClimateChange', true)
        } else {
          formik.setFieldValue('CCIClimateChange', false)
        }
        break

      case 'CCIGenderRelatedSkillsTraining':
        if (e.target.checked === true) {
          formik.setFieldValue('CCIGenderRelatedSkillsTraining', true)
        } else {
          formik.setFieldValue('CCIGenderRelatedSkillsTraining', false)
        }
        break

      case 'CCIFinancialProductDesign':
        if (e.target.checked === true) {
          formik.setFieldValue('CCIFinancialProductDesign', true)
        } else {
          formik.setFieldValue('CCIFinancialProductDesign', false)
        }
        break

      case 'CCIEvaluationCriteriaAnalysis':
        if (e.target.checked === true) {
          formik.setFieldValue('CCIEvaluationCriteriaAnalysis', true)
        } else {
          formik.setFieldValue('CCIEvaluationCriteriaAnalysis', false)
        }
        break

      case 'CCIMonitoringEvaluation':
        if (e.target.checked === true) {
          formik.setFieldValue('CCIMonitoringEvaluation', true)
        } else {
          formik.setFieldValue('CCIMonitoringEvaluation', false)
        }
        break

      case 'CCIOther':
        if (e.target.checked === true) {
          formik.setFieldValue('CCIOther', true)
        } else {
          formik.setFieldValue('CCIOther', false)
        }
        break

      default:
        formik.setValues({
          ...formik.values,
          CCIClimateChangeAdaptation: false,
          CCIClimateChange: false,
          CCIGenderRelatedSkillsTraining: false,
          CCIFinancialProductDesign: false,
          CCIEvaluationCriteriaAnalysis: false,
          CCIMonitoringEvaluation: false,
          CCIOther: false,
        })
        break
    }
  }

  useEffect(() => {
    if (
      formik.values.CCIClimateChangeAdaptation === true ||
      formik.values.CCIClimateChange === true ||
      formik.values.CCIGenderRelatedSkillsTraining === true ||
      formik.values.CCIFinancialProductDesign === true ||
      formik.values.CCIEvaluationCriteriaAnalysis === true ||
      formik.values.CCIMonitoringEvaluation === true ||
      formik.values.CCIOther === true
    ) {
      formik.setFieldValue('validateTechnicalCapacityBuildingForIFI', true)
    } else {
      formik.setFieldValue('validateTechnicalCapacityBuildingForIFI', false)
    }
  }, [
    formik.values.CCIClimateChangeAdaptation,
    formik.values.CCIClimateChange,
    formik.values.CCIGenderRelatedSkillsTraining,
    formik.values.CCIFinancialProductDesign,
    formik.values.CCIEvaluationCriteriaAnalysis,
    formik.values.CCIMonitoringEvaluation,
    formik.values.CCIOther,
  ])

  const handleChangeDeclaration = (e) => {
    switch (e.target.value) {
      case 'IfiBenefitCharge':
        if (e.target.checked === true) {
          formik.setFieldValue('IfiBenefitCharge', true)
        } else {
          formik.setFieldValue('IfiBenefitCharge', false)
        }
        break

      case 'MipymeDeclares':
        if (e.target.checked === true) {
          formik.setFieldValue('MipymeDeclares', true)
        } else {
          formik.setFieldValue('MipymeDeclares', false)
        }
        break

      case 'UnderConditions':
        if (e.target.checked === true) {
          formik.setFieldValue('UnderConditions', true)
        } else {
          formik.setFieldValue('UnderConditions', false)
        }
        break

      default:
        formik.setValues({
          ...formik.values,
          IfiBenefitCharge: false,
          MipymeDeclares: false,
          UnderConditions: false,
        })
        break
    }
  }

  const saveForm = async (values, borrador, exit) => {
    try {
      let object = values
      if (borrador) {
        object = {
          ...values,
          //  Validate: false,
        }
      } else {
        object = {
          ...values,
          Validate: true,
        }
      }

      const response = await insertTechnicalAssistanceAnswers(object)

      if (response.Success) {
        if (borrador) {
          swal({
            title: 'Formulario Guardado',
            icon: 'success',
            button: 'Entendido',
          })

          if (exit) {
            if (edit) {
              history.push(ROUTES.IFIBORRADOR.pathname)
              dispatch({ type: 'SET_STATE', payload: 1 })
            } else {
              history.push('/')
              dispatch({ type: 'SET_STATE', payload: 1 })
            }
          }
          // Swal.fire({
          //   title: `Formulario Guardado

          //            <h4>¿Desea salir?</h4>`,
          //   icon: 'suceess',
          //   showCancelButton: true,
          //   confirmButtonColor: '#3085d6',
          //   cancelButtonColor: '#d33',
          //   confirmButtonText: 'Si',
          //   cancelButtonText: 'No',
          // }).then((result) => {
          //   if (result.isConfirmed) {
          //     createTest()
          //   } else {
          //     updateWorkshop(IdWorkshopStatus)
          //     history.push('/')
          //   }
          // })
        } else {
          if (formik.values.IdTechnicalAssistanceAnswer === 0) {
            formik.setFieldValue(
              'IdTechnicalAssistanceAnswer',
              response.Data.IdTechnicalAssistanceAnswersAnswer,
            )
            formik.setFieldValue(
              'IdForm',
              response.Data.IdTechnicalAssistanceAnswersAnswer,
            )
          } else {
            saveValuesToContext(values)
            next()
          }
        }
      }
    } catch (error) {
      console.log('Error al guardar', error)
    }
  }

  const saveRequestedAmount = async () => {
    try {
      let object = formik.values
      if (formik.values.IdBeneficiaryType === 2) {
        object = {
          ...formik.values,
          Validate: true,
        }
      }

      if (
        formik.values.IdCurrency !== null &&
        formik.values.RequestedAmount !== null
      ) {
        const response = await insertTechnicalAssistanceAnswers(object)

        if (response.Success) {
          setrequestValidate(!requestValidate)
        } else {
          swal({
            title: `Ha ocurrido un problema`,
            text: `El monto de la solicitud de asistencia técnica sobrepasa el límite establecido para la MIPYME`,
            icon: `error`,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: {
              catch: {
                text: 'Continuar',
                value: 'catch',
              },
            },
          })
        }
      }
    } catch (error) {
      console.log('Error al guardar', error)
    }
  }

  useEffect(() => {
    if (!edit) saveForm(formik.values)
  }, [])

  const saveValuesToContext = (values) => {
    setAssistanceForm((previous) => {
      const valuesSave = {
        IdCurrency: values.IdCurrency,
        IdTechnicalAssistanceType: values.IdTechnicalAssistanceType,
        ContactPhoneNumber: values.ContactPhoneNumber,
        ContactEmail: values.ContactEmail,
        ContactAdress: values.ContactAdress,
        IfiBenefitCharge: values.IfiBenefitCharge,
        MipymeDeclares: values.MipymeDeclares,
        UnderConditions: values.UnderConditions,
        TechnicalAssistanceReceivedNumber:
          values.TechnicalAssistanceReceivedNumber,
        IdTechnicalAssistanceAnswer: values.IdTechnicalAssistanceAnswer,
        Draft: values.Draft,
        IdIFI: values.IdIFI,
        IdForm: values.IdForm,
        IdUserAzureB2C: values.IdUserAzureB2C,
        IdBeneficiaryType: values.IdBeneficiaryType,
        ATPDesign: values.ATPDesign,
        ATPEvaluationsEnvironment: values.ATPEvaluationsEnvironment,
        ATPFinancialAndEconomicEvaluations:
          values.ATPFinancialAndEconomicEvaluations,
        ATPFeasibilityStudies: values.ATPFeasibilityStudies,
        ATPBusinessPlanSupport: values.ATPBusinessPlanSupport,
        ATPSupportResourcesWomen: values.ATPSupportResourcesWomen,
        ATPOther: values.ATPOther,
        ATPOtherDescription: values.ATPOtherDescription,
        IdCountry: values.IdCountry,
        RequestedAmount: values.RequestedAmount,
        NumberOfApplicants: values.NumberOfApplicants,
        CCMConstructionClimateChange: values.CCMConstructionClimateChange,
        CCMOrganizationalSkills: values.CCMOrganizationalSkills,
        CCMGenderRelatedSkills: values.CCMGenderRelatedSkills,
        CCMImplementationProcessesClimateChange:
          values.CCMImplementationProcessesClimateChange,
        CCMOther: values.CCMOther,
        CCMOtherDescription: values.CCMOtherDescription,
        CCIClimateChangeAdaptation: values.CCIClimateChangeAdaptation,
        CCIClimateChange: values.CCIClimateChange,
        CCIGenderRelatedSkillsTraining: values.CCIGenderRelatedSkillsTraining,
        CCIFinancialProductDesign: values.CCIFinancialProductDesign,
        CCIEvaluationCriteriaAnalysis: values.CCIEvaluationCriteriaAnalysis,
        CCIMonitoringEvaluation: values.CCIMonitoringEvaluation,
        CCIOther: values.CCIOther,
        CCIOtherDescription: values.CCIOtherDescription,
        CurrencyToDollarExchangeRate: values.CurrencyToDollarExchangeRate,
        PresentationDate: values.PresentationDate,
        NameIFI: values.NameIFI,
      }
      return {
        ...previous,
        ...valuesSave,
      }
    })
  }

  useEffect(() => {
    if (!loading)
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
  }, [loading])

  const handleClose = (event, reason) => {
    setOpen(false)
  }

  const onHiding = async () => {
    setPopupVisible(false)
  }

  const downloadReport = async () => {
    try {
      setPopupVisible(false)
      setReportDownload('')
      let response
      setLoadingPDF(true)
      if (reportDownload === 3)
        response = await reportCapacityBuildingIFI(0, userIDB2C)
      if (reportDownload === 4)
        response = await reportTechnicalAssistancePreinvestment(0, userIDB2C)

      if (reportDownload === 5)
        response = await reportCapacityBuilding(0, userIDB2C)
      if (response.Success) {
        for (
          let j = 0;
          j < response.Data.ReportTechnicalAssistanceAnswers.length;
          j++
        ) {
          const byteCharacters = atob(
            response.Data.ReportTechnicalAssistanceAnswers[j].FileContents,
          )
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const filename =
            response.Data.ReportTechnicalAssistanceAnswers[j].FileName.split(
              '.',
            ).shift()
          const blob = new Blob([byteArray], { type: 'application/pdf' })
          const link = document.createElement('a')

          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.click()
          setLoadingPDF(false)
        }
      }
    } catch (error) {
      console.log(error)
      setLoadingPDF(false)
    }
  }

  return !loading ? (
    <>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => cancelForm()}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        <Grid item>
          <div
            onClick={() => saveForm(formik.values, true)}
            data-tip
            data-for="savePop"
            style={{
              backgroundColor: '#5cb85c',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <SaveIcon />
          </div>
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Guardar Borrador</span>
          </ReactTooltip>
        </Grid>

        <Grid item>
          {/* <div
            // /onClick={() => setPopupVisible(true)}
            // onClick={() => setPopupVisible(true)}
            // data-tip
            // data-for="savePop"
            // style={{
            //   backgroundColor: '#5cb85c',
            //   color: '#fff',
            //   width: '40px',
            //   display: 'flex',
            //   alignItems: 'center',
            //   justifyContent: 'center',
            //   borderRadius: '4px',
            //   padding: '5px',
            //   cursor: 'pointer',
            // }}
            onClick={() => setPopupVisible(true)}
          > */}
          {/* <FileDownloadIcon style={{ transform: 'scaleX(-1)' }} /> */}

          <LoadingButton
            loadingPosition="start"
            variant="contained"
            onClick={() => setPopupVisible(true)}
            startIcon={<FileDownloadIcon style={{ transform: 'scaleX(-1)' }} />}
            loading={loadingPDF}
            style={{
              backgroundColor: '#5cb85c',
              color: '#fff',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              // padding: '5px',
              cursor: 'pointer',
            }}
          ></LoadingButton>

          {/* modal reporte */}
          <Popup
            title="Seleccione reporte a descargar"
            showTitle={true}
            width={500}
            height={270}
            visible={popupVisible}
            hideOnOutsideClick
            onHiding={onHiding}
          >
            <Grid container spacing={1}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  id="TypeTechnicalAssistance"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  value={reportDownload}
                  onChange={(e) => {
                    setReportDownload(Number(e.target.value))
                  }}
                >
                  <FormControlLabel
                    value={4}
                    control={<Radio />}
                    label="Asistencia técnica para pre-inversión de MIPYME"
                  />
                  <FormControlLabel
                    value={5}
                    control={<Radio />}
                    label="Construcción de capacidades para MIPYME"
                  />
                  <FormControlLabel
                    value={3}
                    control={<Radio />}
                    label="Construcción de capacidades para IFI"
                  />
                </RadioGroup>
              </FormControl>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={onHiding}>
                  Cancelar
                </Button>

                <Button className="confirmButton" onClick={downloadReport}>
                  Aceptar
                </Button>
              </Grid>
            </Grid>
          </Popup>
          {/* </div> */}
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Descargar</span>
          </ReactTooltip>
        </Grid>
      </Grid>
      <form id="transfers-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">Información sobre el Beneficiario</h1>
          <br />
        </Grid>

        <Grid container spacing={1}>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1. Tipo de Beneficiario <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  id="TypeBeneficiary"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  row
                  value={formik.values.IdBeneficiaryType}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'IdBeneficiaryType',
                      Number(e.target.value),
                    )
                    if (Number(e.target.value) === 2) {
                      formik.setFieldValue('IdTechnicalAssistanceType', 3)
                      setEnableSec3(true)
                    } else {
                      if (formik.values.IdTechnicalAssistanceType === 3)
                        formik.setFieldValue('IdTechnicalAssistanceType', 4)
                      setEnableSec3(false)
                    }
                    if (Number(e.target.value) === 1) {
                      formik.setFieldValue('NumberOfApplicants', 1)
                    }

                    if (Number(e.target.value) === 3) {
                      formik.setFieldValue('NumberOfApplicants', null)
                    }
                  }}
                >
                  <FormControlLabel
                    value={1}
                    control={<Radio />}
                    label="MIPYME"
                    disabled={disabled}
                  />
                  <FormControlLabel
                    value={2}
                    control={<Radio />}
                    label="IFI"
                    disabled={disabled}
                  />
                  <FormControlLabel
                    value={3}
                    control={<Radio />}
                    label="Grupo de MIPYME (Asociaciones, cooperativas, otros)"
                    disabled={disabled}
                  />
                </RadioGroup>
                {formik.errors.IdBeneficiaryType ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.IdBeneficiaryType}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2. Tipo de asistencia técnica{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  id="TypeTechnicalAssistance"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  value={formik.values.IdTechnicalAssistanceType}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'IdTechnicalAssistanceType',
                      Number(e.target.value),
                    )
                  }}
                >
                  <FormControlLabel
                    value={4}
                    control={<Radio />}
                    label="Asistencia técnica para pre-inversión de MIPYME"
                    disabled={formik.values.IdBeneficiaryType === 2 || disabled}
                  />
                  <FormControlLabel
                    value={5}
                    control={<Radio />}
                    label="Construcción de capacidades para MIPYME"
                    disabled={formik.values.IdBeneficiaryType === 2 || disabled}
                  />
                  <FormControlLabel
                    value={3}
                    control={<Radio />}
                    label="Construcción de capacidades para IFI"
                    disabled={
                      formik.values.IdBeneficiaryType === 1 ||
                      formik.values.IdBeneficiaryType === 3 ||
                      disabled
                    }
                  />
                </RadioGroup>
                {formik.errors.IdTechnicalAssistanceType ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.IdTechnicalAssistanceType}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={
                  formik.errors.IdCurrency ||
                  formik.errors.RequestedAmount ||
                  formik.errors.NumberOfApplicants ||
                  formik.errors.validateTable13
                    ? { border: '2px solid red' }
                    : {}
                }
              >
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    {/* 3. Nombre(s) del (de los) solicitante(s) */}
                    3. Información de la solicitud
                  </label>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Grid
                  container
                  spacing={1}
                  className="input__container"
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'end',
                  }}
                >
                  <Grid item xs={4} sm={4} md={4}>
                    <label>
                      Moneda <span style={{ color: 'red' }}>*</span>
                    </label>
                    <FormControl fullWidth>
                      <Select
                        id="currencyBudget"
                        name="currencyBudget"
                        variant="outlined"
                        onChange={(e) => {
                          formik.setFieldValue('IdCurrency', e.target.value)
                        }}
                        value={formik.values.IdCurrency}
                      >
                        <MenuItem value={''} disabled>
                          Seleccione una opción
                        </MenuItem>
                        {currencyType &&
                          currencyType.map((item) => (
                            <MenuItem
                              key={item.IdCurrency}
                              value={item.IdCurrency}
                            >
                              {item.Description}
                            </MenuItem>
                          ))}
                      </Select>
                      {formik.errors.IdCurrency ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.IdCurrency}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>

                  <Grid item xs={4} sm={4} md={4}>
                    <label className="responsiveLabel">
                      Monto solicitado correspondiente a contrapartida CAMBio II{' '}
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                    <FormControl fullWidth>
                      <NumberFormat
                        id="numberAss"
                        style={{ width: '100%' }}
                        customInput={TextField}
                        thousandSeparator={true}
                        variant="outlined"
                        allowNegative={false}
                        onChange={(e) => {
                          formik.setFieldValue(
                            'RequestedAmount',
                            Number(e.target.value.replaceAll(',', '')),
                          )
                        }}
                        value={formik.values.RequestedAmount}
                        error={formik.errors.RequestedAmount}
                        fixedDecimalScale
                        onBlur={() => saveRequestedAmount()}
                        decimalScale={2}
                        allowLeadingZeros={false}
                      />
                    </FormControl>
                    {formik.errors.RequestedAmount ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.RequestedAmount}
                      </div>
                    ) : null}
                  </Grid>

                  {formik.values.IdBeneficiaryType === 3 ? (
                    <>
                      <Grid item xs={4} sm={4} md={4}>
                        <label>
                          Número de MIPYME{' '}
                          <span style={{ color: 'red' }}>*</span>
                        </label>
                        <FormControl fullWidth>
                          <NumberFormat
                            id="numberAss"
                            style={{ width: '100%' }}
                            customInput={TextField}
                            thousandSeparator={true}
                            variant="outlined"
                            allowNegative={false}
                            onChange={(e) => {
                              formik.setFieldValue(
                                'NumberOfApplicants',
                                Number(e.target.value.replaceAll(',', '')),
                              )
                            }}
                            value={formik.values.NumberOfApplicants}
                            error={formik.errors.NumberOfApplicants}
                            onBlur={saveRequestedAmount}
                            decimalScale={0}
                            inputProps={{ maxLength: 3 }}
                            allowLeadingZeros={false}
                          />
                          {formik.errors.NumberOfApplicants ? (
                            <div
                              style={{
                                color: 'red',
                                marginTop: '3px',
                                fontSize: '13px',
                              }}
                            >
                              {formik.errors.NumberOfApplicants}
                            </div>
                          ) : null}
                        </FormControl>
                      </Grid>
                      <label
                        style={{
                          color: 'gray',
                          fontSize: '13px',
                          marginLeft: '68%',
                        }}
                      >
                        Ingrese al menos dos MIPYME
                      </label>
                    </>
                  ) : null}

                  {/* {formik.values.IdBeneficiaryType === 2 ? (
                        <Grid
                          item
                          xs={4}
                          sm={4}
                          md={4}
                          style={{
                            ali: 'flex-end',
                          }}
                        >
                          <FormControl fullWidth>
                            <Button
                              type="button"
                              onClick={() => console.log('prueba')}
                              className="button__wizard button__next"
                            >
                              Registrar
                            </Button>
                          </FormControl>
                        </Grid>
                      ) : null} */}

                  <Grid container spacing={1} className="input__container">
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      style={{ marginBottom: '2%' }}
                    >
                      <label>
                        Nombre(s) del (de los) solicitante(s){' '}
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                    </Grid>
                  </Grid>
                  {formik.values.IdBeneficiaryType !== 2 ? (
                    <Grid item xs={12} sm={12} md={12}>
                      <Table13
                        IdBeneficiaryType={formik.values.IdBeneficiaryType}
                        IdTechnicalAssistanceType={
                          formik.values.IdTechnicalAssistanceType
                        }
                        IdCurrency={formik.values.IdCurrency}
                        IdTechnicalAssistanceAnswer={
                          formik.values.IdTechnicalAssistanceAnswer
                        }
                        RequestedAmount={formik.values.RequestedAmount}
                        NumberOfApplicants={formik.values.NumberOfApplicants}
                        formik={formik.setFieldValue}
                        setDisabled={setDisabled}
                        CurrencyToDollarExchangeRate={
                          formik.values.CurrencyToDollarExchangeRate
                        }
                        requestValidate={requestValidate}
                      />
                      {formik.errors.validateTable13 ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.validateTable13}
                        </div>
                      ) : null}
                    </Grid>
                  ) : (
                    <Grid container spacing={1} className="input__container">
                      <Grid item xs={12} sm={12} md={12}>
                        <label className="responsiveLabel">
                          Institución Financiera
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <TextField
                            id="MiPymeCountry"
                            name="MiPymeCountry"
                            type="text"
                            variant="outlined"
                            sx={{ width: 220 }}
                            disabled
                            value={formik.values.NameIFI}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">4. País</label>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <FormControl fullWidth>
              <Stack noValidate spacing={3}>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: 220 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                  value={formik.values.IFICountry}
                />
              </Stack>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">5. Datos del contacto</label>
          </Grid>

          <Grid item xs={4} sm={4} md={4}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Número de teléfono fijo o celular{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <FormControl fullWidth>
              {/* <TextField
                id="IdCurrencyUser"
                name="IdCurrencyUser"
                style={{ width: '100%' }}
                variant="outlined"
                value={formik.values.ContactPhoneNumber}
                onChange={(e) => {
                  formik.setFieldValue('ContactPhoneNumber', e.target.value)
                }}
                error={formik.errors.ContactPhoneNumber}
              />
               */}
              <PhoneInput
                id="phone"
                localization={es}
                country={
                  userCountry === '1'
                    ? 'cr'
                    : userCountry === '2'
                    ? 'gt'
                    : userCountry === '3'
                    ? 'hn'
                    : userCountry === '4'
                    ? 'ni'
                    : userCountry === '5'
                    ? 'sv'
                    : userCountry === '6'
                    ? 'pa'
                    : userCountry === '7' && 'do'
                }
                onlyCountries={
                  userCountry === '1'
                    ? ['cr']
                    : userCountry === '2'
                    ? ['gt']
                    : userCountry === '3'
                    ? ['hn']
                    : userCountry === '4'
                    ? ['ni']
                    : userCountry === '5'
                    ? ['sv']
                    : userCountry === '6'
                    ? ['pa']
                    : userCountry === '7' && ['do']
                }
                masks={{
                  pa: '........',
                  hn: '........',
                  ni: '........',
                  gt: '........',
                  cr: '........',
                  sv: '........',
                  do: '(...) ........',
                }}
                countryCodeEditable={userCountry !== '7' ? false : editableCode}
                enableAreaCodes={true}
                enableAreaCodeStretch
                areaCodes={{ do: ['809', '829', '849'] }}
                disableDropdown={userCountry !== '7'}
                inputProps={{
                  name: 'phone',
                  required: true,
                  autoFocus: true,
                  autoComplete: 'off',
                }}
                jumpCursorToEnd={true}
                inputClass="phone"
                value={phone}
                onKeyDown={(e) => (userCountry === '7' ? handleEdit(e) : '')}
                onChange={(value, country, e, formattedValue) => {
                  setPhone(value)
                  if (userCountry !== '7') {
                    if (value.length !== 3) {
                      formik.setFieldValue('ContactPhoneNumber', value)
                    } else {
                      formik.setFieldValue('ContactPhoneNumber', '')
                    }
                  } else {
                    if (value.length !== 4) {
                      formik.setFieldValue('ContactPhoneNumber', value)
                    } else {
                      formik.setFieldValue('ContactPhoneNumber', '')
                    }
                  }
                }}
                dropdownClass={userCountry === '7' ? 'dropClass' : ''}
              />

              {formik.errors.ContactPhoneNumber ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.ContactPhoneNumber}
                </div>
              ) : null}
            </FormControl>
          </Grid>

          <Grid item xs={8} sm={8} md={8}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Correo electrónico <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <FormControl fullWidth>
              <TextField
                id="IdCurrencyUser"
                name="IdCurrencyUser"
                style={{ width: '100%' }}
                variant="outlined"
                value={formik.values.ContactEmail}
                onChange={(e) => {
                  formik.setFieldValue('ContactEmail', e.target.value)
                }}
                error={formik.errors.ContactEmail}
                inputProps={{
                  maxLength: 100,
                }}
              />
              {formik.errors.ContactEmail ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.ContactEmail}
                </div>
              ) : null}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Dirección <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <FormControl fullWidth>
              <textarea
                id="ClimateThreat"
                placeholder="Dirección"
                customInput={TextField}
                value={formik.values.ContactAdress}
                onChange={(e) => {
                  formik.setFieldValue('ContactAdress', e.target.value)
                }}
                error={formik.errors.ContactAdress}
                maxLength={500}
              ></textarea>
              {formik.errors.ContactAdress ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.ContactAdress}
                </div>
              ) : null}
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={
                  formik.errors.ATPOtherDescription ||
                  formik.errors.validateTechnicalAssistanceforPreinvestment ||
                  formik.errors.CCMOtherDescription ||
                  formik.errors
                    .validateTechnicalAssistanceCapacityBuildingForMipymes ||
                  formik.errors.CCIOtherDescription ||
                  formik.errors.validateTechnicalCapacityBuildingForIFI
                    ? { border: '2px solid red' }
                    : {}
                }
              >
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    6. Asistencia técnica solicitada{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                {formik.values.IdTechnicalAssistanceType === 4 ? (
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Seleccione la acción correspondiente, solicitada por
                        medio de la asistencia técnica.
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <label
                        className="responsiveLabel"
                        style={{ 'text-decoration': 'underline' }}
                      >
                        Asistencias técnicas para preinversión
                      </label>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeTechnicalAssistanceforPreinvestment(
                                    e,
                                  )
                                }
                                value="ATPDesign"
                                checked={!!formik.values.ATPDesign}
                              />
                            }
                            label="Diseño finales de proyectos de adaptación"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeTechnicalAssistanceforPreinvestment(
                                    e,
                                  )
                                }
                                value="ATPEvaluationsEnvironment"
                                checked={
                                  !!formik.values.ATPEvaluationsEnvironment
                                }
                              />
                            }
                            label="Evaluaciones / Análisis ambientales"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeTechnicalAssistanceforPreinvestment(
                                    e,
                                  )
                                }
                                value="ATPFinancialAndEconomicEvaluations"
                                checked={
                                  !!formik.values
                                    .ATPFinancialAndEconomicEvaluations
                                }
                              />
                            }
                            label="Evaluaciones financieras y económicas"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeTechnicalAssistanceforPreinvestment(
                                    e,
                                  )
                                }
                                value="ATPFeasibilityStudies"
                                checked={!!formik.values.ATPFeasibilityStudies}
                              />
                            }
                            label="Estudios de factibilidad"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeTechnicalAssistanceforPreinvestment(
                                    e,
                                  )
                                }
                                value="ATPBusinessPlanSupport"
                                checked={!!formik.values.ATPBusinessPlanSupport}
                              />
                            }
                            label="Apoyo al diseño final de plan de negocio, para obtener el préstamo "
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeTechnicalAssistanceforPreinvestment(
                                    e,
                                  )
                                }
                                value="ATPSupportResourcesWomen"
                                checked={
                                  !!formik.values.ATPSupportResourcesWomen
                                }
                              />
                            }
                            label="Recursos  para apoyar a las mujeres en el campo y facilitar su participación en las actividades del programa"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeTechnicalAssistanceforPreinvestment(
                                    e,
                                  )
                                }
                                value="ATPOther"
                                checked={!!formik.values.ATPOther}
                              />
                            }
                            label="Otra: Especifique"
                          />
                        </FormGroup>
                      </Grid>
                      {formik.values.ATPOther && (
                        <Grid
                          container
                          spacing={1}
                          className="input__container"
                        >
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12}>
                              <FormControl style={{ width: '100%' }}>
                                <TextField
                                  id="Others94"
                                  style={{ width: '100%' }}
                                  // error={!!formik.errors.ATPOtherDescription}
                                  variant="outlined"
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      'ATPOtherDescription',
                                      e.target.value,
                                    )
                                  }}
                                  inputProps={{
                                    maxLength: 80,
                                  }}
                                  value={formik.values.ATPOtherDescription}
                                  error={formik.errors.ATPOtherDescription}
                                />
                                {formik.errors.ATPOtherDescription ? (
                                  <div
                                    style={{
                                      color: 'red',
                                      marginTop: '3px',
                                      fontSize: '13px',
                                    }}
                                  >
                                    {formik.errors.ATPOtherDescription}
                                  </div>
                                ) : null}
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                    {formik.errors
                      .validateTechnicalAssistanceforPreinvestment ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {
                          formik.errors
                            .validateTechnicalAssistanceforPreinvestment
                        }
                      </div>
                    ) : null}
                  </Grid>
                ) : null}
                {formik.values.IdTechnicalAssistanceType === 5 ? (
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Seleccione la acción correspondiente, solicitada por
                        medio de la asistencia técnica.
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <label
                        className="responsiveLabel"
                        style={{ 'text-decoration': 'underline' }}
                      >
                        Construcción de capacidades para MIPYME
                      </label>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForMipymes(e)
                                }
                                value="CCMConstructionClimateChange"
                                checked={
                                  !!formik.values.CCMConstructionClimateChange
                                }
                              />
                            }
                            label="Construcción de capacidades sobre medidas de adaptación al cambio climático"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForMipymes(e)
                                }
                                value="CCMOrganizationalSkills"
                                checked={
                                  !!formik.values.CCMOrganizationalSkills
                                }
                              />
                            }
                            label="Construcción de capacidades sobre habilidades organizacionales"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForMipymes(e)
                                }
                                value="CCMGenderRelatedSkills"
                                checked={!!formik.values.CCMGenderRelatedSkills}
                              />
                            }
                            label="Construcción de capacidades en temáticas de género."
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForMipymes(e)
                                }
                                checked={
                                  !!formik.values
                                    .CCMImplementationProcessesClimateChange
                                }
                                value="CCMImplementationProcessesClimateChange"
                              />
                            }
                            label="Procesos de implementación para certificaciones de cambio climático (ejem. Biodiversity check, Economía Azul, Bandera Azul, Q de Calidad...)"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForMipymes(e)
                                }
                                value="CCMOther"
                                checked={!!formik.values.CCMOther}
                              />
                            }
                            label="Otra: Especifique"
                          />
                        </FormGroup>
                      </Grid>
                      {formik.values.CCMOther && (
                        <Grid
                          container
                          spacing={1}
                          className="input__container"
                        >
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12}>
                              <FormControl style={{ width: '100%' }}>
                                <TextField
                                  id="Others94"
                                  style={{ width: '100%' }}
                                  variant="outlined"
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      'CCMOtherDescription',
                                      e.target.value,
                                    )
                                  }}
                                  inputProps={{
                                    maxLength: 80,
                                  }}
                                  value={formik.values.CCMOtherDescription}
                                  error={formik.errors.CCMOtherDescription}
                                />
                                {formik.errors.CCMOtherDescription ? (
                                  <div
                                    style={{
                                      color: 'red',
                                      marginTop: '3px',
                                      fontSize: '13px',
                                    }}
                                  >
                                    {formik.errors.CCMOtherDescription}
                                  </div>
                                ) : null}
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                    {formik.errors
                      .validateTechnicalAssistanceCapacityBuildingForMipymes ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {
                          formik.errors
                            .validateTechnicalAssistanceCapacityBuildingForMipymes
                        }
                      </div>
                    ) : null}
                  </Grid>
                ) : null}

                {formik.values.IdTechnicalAssistanceType === 3 ? (
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Seleccione la acción correspondiente, solicitada por
                        medio de la asistencia técnica.
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <label
                        className="responsiveLabel"
                        style={{ 'text-decoration': 'underline' }}
                      >
                        Construcción de capacidades para IFI.
                      </label>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForIFI(e)
                                }
                                value="CCIClimateChangeAdaptation"
                                checked={
                                  !!formik.values.CCIClimateChangeAdaptation
                                }
                              />
                            }
                            label="Adaptación al cambio climático, y evaluación de riesgos ambientales y sociales, para el equipo interno de la IFI"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForIFI(e)
                                }
                                value="CCIClimateChange"
                                checked={!!formik.values.CCIClimateChange}
                              />
                            }
                            label="Construcción de programas de adaptación al cambio climático, inherentes a la IFI"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForIFI(e)
                                }
                                value="CCIGenderRelatedSkillsTraining"
                                checked={
                                  !!formik.values.CCIGenderRelatedSkillsTraining
                                }
                              />
                            }
                            label="Capacitación en temáticas de género para las IFI"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForIFI(e)
                                }
                                value="CCIFinancialProductDesign"
                                checked={
                                  !!formik.values.CCIFinancialProductDesign
                                }
                              />
                            }
                            label="Diseño de productos financieros ad-hoc, para atender inversiones relacionadas con la adaptación al cambio climático"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForIFI(e)
                                }
                                value="CCIEvaluationCriteriaAnalysis"
                                checked={
                                  !!formik.values.CCIEvaluationCriteriaAnalysis
                                }
                              />
                            }
                            label="Análisis de criterios de evaluación de inversiones para la introducción de medidas de adaptación al cambio climático"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForIFI(e)
                                }
                                value="CCIMonitoringEvaluation"
                                checked={
                                  !!formik.values.CCIMonitoringEvaluation
                                }
                              />
                            }
                            label="Monitoreo y evaluación de inversiones"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeCapacityBuildingForIFI(e)
                                }
                                value="CCIOther"
                              />
                            }
                            label="Otra: Especifique"
                            checked={!!formik.values.CCIOther}
                          />
                        </FormGroup>
                      </Grid>
                      {formik.values.CCIOther && (
                        <Grid
                          container
                          spacing={1}
                          className="input__container"
                        >
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12}>
                              <FormControl style={{ width: '100%' }}>
                                <TextField
                                  id="Others94"
                                  style={{ width: '100%' }}
                                  variant="outlined"
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      'CCIOtherDescription',
                                      e.target.value,
                                    )
                                  }}
                                  inputProps={{
                                    maxLength: 80,
                                  }}
                                  value={formik.values.CCIOtherDescription}
                                  error={formik.errors.CCIOtherDescription}
                                />
                                {formik.errors.CCIOtherDescription ? (
                                  <div
                                    style={{
                                      color: 'red',
                                      marginTop: '3px',
                                      fontSize: '13px',
                                    }}
                                  >
                                    {formik.errors.CCIOtherDescription}
                                  </div>
                                ) : null}
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                    {formik.errors.validateTechnicalCapacityBuildingForIFI ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.validateTechnicalCapacityBuildingForIFI}
                      </div>
                    ) : null}
                  </Grid>
                ) : null}
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.TechnicalAssistanceReceivedNumber ||
              formik.errors.validateTable17
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Grid item xs={12} sm={12} md={12}>
              <label
                className="responsiveLabel"
                style={{
                  fontWeight: 500,
                  fontSize: '1.05rem',
                  color: '#3f4254',
                }}
              >
                7. Asistencia técnica recibida en los últimos 5 años{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Describa las diferentes asistencias técnicas recibidas en los
                últimos 5 años, incluyendo las financiadas por el BCIE, ONG u
                otras instituciones, así como las asistencias técnicas privadas
                que haya contratado
              </label>
            </Grid>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={4} sm={4} md={4}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Número de asistencias técnicas{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <FormControl fullWidth>
                  <NumberFormat
                    id="numberAss"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    allowNegative={false}
                    value={formik.values.TechnicalAssistanceReceivedNumber}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'TechnicalAssistanceReceivedNumber',
                        Number(e.target.value.replaceAll(',', '')),
                      )
                    }}
                    error={formik.errors.TechnicalAssistanceReceivedNumber}
                    inputProps={{ maxLength: 3 }}
                    decimalScale={0}
                    allowLeadingZeros={false}
                  />
                  {formik.errors.TechnicalAssistanceReceivedNumber ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.TechnicalAssistanceReceivedNumber}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                {/* Tabla Asistencia */}
                <Grid item xs={12} sm={12} md={12}>
                  <Table17
                    TechnicalAssistanceReceivedNumber={
                      formik.values.TechnicalAssistanceReceivedNumber
                    }
                    IdTechnicalAssistanceAnswer={
                      formik.values.IdTechnicalAssistanceAnswer
                    }
                    formik={formik.setFieldValue}
                  />
                  {formik.errors.validateTable17 ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.validateTable17}
                    </div>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>{' '}
          </AccordionDetails>
        </Accordion>

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => handleChangeDeclaration(e)}
                    value="IfiBenefitCharge"
                    checked={!!formik.values.IfiBenefitCharge}
                  />
                }
                label={
                  <>
                    Declaro que nosotros como Institución Financiera no cobramos
                    a la MIPYME por este beneficio.{''}
                    <span style={{ color: 'red' }}>*</span>
                  </>
                }
              />
              {formik.errors.IfiBenefitCharge ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.IfiBenefitCharge}
                </div>
              ) : null}

              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => handleChangeDeclaration(e)}
                    value="MipymeDeclares"
                    checked={!!formik.values.MipymeDeclares}
                  />
                }
                label={
                  <>
                    Declaro que la MIPYME no recibe apoyo para la ejecución de
                    la parte de la asistencia técnica solicitada a CAMBIO II,
                    por parte de ninguna otra institución.{''}
                    <span style={{ color: 'red' }}>*</span>
                  </>
                }
              />
              {formik.errors.MipymeDeclares ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.MipymeDeclares}
                </div>
              ) : null}
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => handleChangeDeclaration(e)}
                    value="UnderConditions"
                    checked={!!formik.values.UnderConditions}
                  />
                }
                label={
                  <>
                    Bajo los requisitos de crédito de la Institución Financiera,
                    la MIPYME es elegible para recibir financiamiento.{''}
                    <span style={{ color: 'red' }}>*</span>
                  </>
                }
              />
              {formik.errors.UnderConditions ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.UnderConditions}
                </div>
              ) : null}
            </FormGroup>
          </Grid>
        </Grid>

        <Grid container spacing={1} className="general_button">
          <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
            <Button
              type="button"
              onClick={() => validateFormStatus()}
              className="button__wizard button__next"
            >
              Siguiente
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  ) : (
    <Box className="loadingEditContainer">
      <Grid className="loadingSub">
        <CircularProgress />
      </Grid>
    </Box>
  )
}
